import styles from "../style";
import {
  Navbar,
  Footer,
  CTA,
  // existing demo sections (we’ll place them under ATG Pro)
  LiveTankDisplays,
  AlarmDemo,
  ChartDemo,
} from "./react-public";

// new sections you’ll add:
import ProductsOverview from "./react-public/Products/ProductsOverview";
import ATGProSection from "./react-public/Products/ATGProSection";
import BackOfficeSection from "./react-public/Products/BackOfficeSection";
import ATGCommanderSection from "./react-public/Products/ATGCommanderSection";

const Products = () => {
  return (
    <div className="bg-primary w-full">
      <div className={`${styles.paddingX} ${styles.flexCenter}`}>
        <div className={`${styles.boxWidth}`}>
          <Navbar />
        </div>
      </div>

      <div className={`bg-primary ${styles.flexStart}`}>
        <div className={`${styles.boxWidth}`}>
          {/* Top summary of your 3-product ecosystem */}
          <ProductsOverview />

          {/* Product 1 */}
          <ATGProSection />
          <LiveTankDisplays />
          <AlarmDemo />
          <ChartDemo />

          {/* Product 2 */}
          <BackOfficeSection />

          {/* Product 3 */}
          <ATGCommanderSection />

          <CTA />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Products;
